import { render, staticRenderFns } from "./TopicHome.vue?vue&type=template&id=60a71ce1&scoped=true&"
import script from "./TopicHome.vue?vue&type=script&lang=js&"
export * from "./TopicHome.vue?vue&type=script&lang=js&"
import style0 from "./TopicHome.vue?vue&type=style&index=0&id=60a71ce1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a71ce1",
  null
  
)

export default component.exports